// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2INNU","inputDescription":"styles_inputDescription__k2NO0"};